// Helpers for translating a view's per-column reorder back into the single
// global task order persisted via `position` (see POST /api/lists/{id}/reorder).

/**
 * Rebuild the full ordered list of task IDs after an intra-column move.
 *
 * Columns in the Kanban/Milestone views are filtered slices of the globally
 * position-ordered `allTasks` array, so within-column order already equals the
 * relative global order for that subset. To persist a reorder we walk the
 * original `allTasks` and, wherever a task belongs to the affected column, emit
 * the next ID from the column's new order; otherwise we keep the original ID.
 * This preserves every other task's position and returns exactly
 * `allTasks.length` IDs.
 *
 * For a cross-column move, include the moved ID in BOTH `affectedIds` and
 * `newColumnOrder` so its original physical slot is consumed and it lands at
 * the chosen position.
 *
 * @param {Array<{id: string}>} allTasks - full, globally-ordered task objects
 * @param {Set<string>} affectedIds - IDs in the affected column AFTER the move
 * @param {string[]} newColumnOrder - the affected column's new ID order
 * @returns {string[]} full ordered task IDs for the list
 */
export function rebuildFullOrder(allTasks, affectedIds, newColumnOrder) {
  const queue = [...newColumnOrder];
  return allTasks.map((t) => (affectedIds.has(t.id) ? queue.shift() : t.id));
}
